<template>
    <div class="bg-white py-16 sm:py-24">
        <Container>
            <SectionHeading eyebrow="Why us" title="Best Arabic & Qur'an Learning Experience" />

            <div class="mx-auto mt-12 grid max-w-2xl grid-cols-1 gap-6 sm:mt-16 sm:grid-cols-2 lg:max-w-none lg:grid-cols-3">
                <div v-for="feature in features" :key="feature.name"
                    class="group relative rounded-2xl border border-gray-100 bg-gray-50/60 p-8 transition-all duration-200 hover:-translate-y-1 hover:border-primary-100 hover:bg-white hover:shadow-xl hover:shadow-gray-900/5">
                    <div class="flex size-12 items-center justify-center rounded-xl bg-white shadow-sm ring-1 ring-gray-900/5">
                        <img v-if="feature.icon" :src="feature.icon" alt="" class="size-6" />
                    </div>
                    <h3 class="mt-6 text-base font-semibold text-gray-900">{{ feature.name }}</h3>
                    <p class="mt-2 text-sm/6 text-gray-600">{{ feature.description }}</p>
                </div>
            </div>
        </Container>
    </div>
</template>

<script setup>
import Container from '@/components/ui/Container.vue';
import SectionHeading from '@/components/ui/SectionHeading.vue';

const features = [
    {
        name: 'Native Arabic Tutors',
        description: 'Our tutors are native Arabic speakers, ensuring an authentic learning experience.',
        icon: 'images/icons/features/arabic.png',
    },
    {
        name: 'Flexible Scheduling',
        description: 'Choose your own schedule and learn at your own pace.',
        icon: 'images/icons/features/calendar.png',
    },
    {
        name: 'Interactive Learning',
        description: 'Engaging lessons with interactive tools and resources.',
        icon: 'images/icons/features/chat.png',
    },
    {
        name: 'Certified Tutors',
        description: 'Al-Azhar certified professional teachers are available.',
        icon: 'images/icons/features/certified.png',
    },
    {
        name: 'Comprehensive Curriculum',
        description: 'A well-structured curriculum covering all aspects of Arabic and Quranic studies.',
        icon: 'images/icons/features/zip.png',
    },
    {
        name: '24/7 Support',
        description: 'Our support team is available around the clock to assist you.',
        icon: 'images/icons/features/support.png',
    },
]
</script>
